"use client"

import SRKR from "../Images/SRKREC.jpeg"
import Sumeru from "../Images/sumeru.jpg"
import Saptarishi from "../Images/saptarishi.png"

const Experience = () => {
  const educationData = [
    {
      id: 1,
      institution: "Saptarishi Solutions Pvt. Ltd.",
      degree: "Full Stack Developer",
      location: "Miyapur,Hyderabad",
      duration: "Oct 2025 - Present",
      description:
        "As a Full Stack Developer at Saptarishi Solutions, I am responsible for designing and developing scalable web applications, including an HRMS platform and more. I lead the development process, working with modern technologies such as Next.js and backend services to build dynamic features, manage data workflows, and ensure smooth integration between frontend and backend systems. In this role, I also guide development decisions, collaborate with team members, and oversee key modules to deliver efficient and reliable enterprise solutions. This experience has strengthened my expertise in full-stack development, system architecture, and technical leadership in real-world production environments.",
      image: Saptarishi,
    },
    {
      id: 2,
      institution: "Sumeru Technology Solutions Pvt. Ltd.",
      degree: "Engineering Intern",
      location: "Bengaluru,Karnataka",
      duration: "Dec 2024 - Oct 2025",
      description:
        "As an Engineering Intern at Sumeru, I contributed to building and optimizing web applications using Next.js and Supabase. I was involved in developing dynamic features, managing backend services, and ensuring seamless integration between frontend and backend components. This hands-on experience enhanced my full-stack development skills and deepened my understanding of modern web technologies and collaborative development workflows.",
      image: Sumeru,
    },
    {
      id: 3,
      institution: "Vedic Vision Hackathon",
      degree: "Full Stack Mentor",
      location: "Bhimavaram, AndhraPradesh",
      duration: "Aug 2024",
      description:
        "As the Full Stack Mentor for the Tech team in the Vedic Vision Hackathon, I guided participants through the end-to-end development process, offering support in technologies like React, Node.js, and MongoDB. I helped the team architect scalable solutions, debug complex issues, and ensure timely delivery of features. This mentorship role strengthened my leadership, technical communication, and team collaboration skills while fostering innovation under tight deadlines.",
      image: SRKR,
    },
    // {
    //   id: 3,
    //   institution: "Sri Siddartha EM High School",
    //   degree: "Board of Secondary Education, S.S.C.",
    //   location: "Ravulapalem, AndhraPradesh",
    //   duration: "2018 - 2019",
    //   description:
    //     "I embarked on my academic journey at Sri Siddartha EM High School, where I remained committed from LKG to 10th grade. Throughout this period, I not only gained valuable knowledge in various subjects but also acquired insights into both educational and personal matters. The continuity of my education at the same school allowed me to build a strong foundation and foster a deep connection with my learning environment. This experience has significantly contributed to my holistic growth, shaping both my academic and personal perspectives.",
    //   image: SRKR,
    // },
  ];

  return (
    <section className="min-h-screen bg-bg-primary px-[9%] py-[10rem] relative" id="experience">
      {/* Custom Shape Divider */}
      <div className="absolute top-0 left-0 w-full overflow-hidden leading-none">
        <svg
          className="relative block w-[calc(300%+1.3px)] h-16"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path
            d="M0,0V7.23C0,65.52,268.63,112.77,600,112.77S1200,65.52,1200,7.23V0Z"
            className="fill-bg-secondary"
          ></path>
        </svg>
      </div>


      <div className="flex flex-col justify-center items-center relative z-10 pb-[60px]">
        <div className="relative flex flex-col items-center w-full max-w-[1350px] pt-[40px] gap-3">
          <h2 className="text-[32px] md:text-[42px] text-center font-semibold mt-5 text-white font-rowdies">
            Experience
          </h2>
          <p className="text-[16px] md:text-[18px] text-center max-w-[600px] text-white mb-8">
            My professional journey has been a path of self-discovery, continuous learning, and personal growth through diverse experiences.
          </p>

          {/* One-by-one cards */}
          <div className="w-full max-w-[700px] flex flex-col gap-8 mt-10">
            {educationData.map((edu) => (
              <div key={edu.id} className="w-full">
                <div className="w-full rounded-[10px] shadow-[rgba(219,216,216,0.15)_0px_8px_24px] p-[12px_16px] justify-between relative overflow-hidden flex flex-col gap-3 transition-all duration-300 border border-white hover:shadow-[0px_0px_20px_rgba(250,250,250,0.2)] hover:-translate-y-[5px] group">
                  <div className="w-full flex gap-3">
                    <img
                      src={edu.image || "/placeholder.svg"}
                      alt={edu.institution}
                      className="h-[50px] bg-white rounded-[10px] mt-1"
                    />
                    <div className="w-full flex flex-col">
                      <div className="text-[18px] font-semibold text-white">{edu.institution}</div>
                      <div className="text-[14px] font-medium text-white">{edu.degree}</div>
                      <div className="text-[14px] font-medium text-white">{edu.location}</div>
                      <div className="text-[14px] font-medium text-white">{edu.duration}</div>
                    </div>
                  </div>
                  <div className="text-[15px] font-normal text-white mb-[10px] overflow-hidden max-w-full line-clamp-4 text-ellipsis group-hover:line-clamp-none group-hover:overflow-visible">
                    {edu.description}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
